module.exports = __webpack_public_path__ + "img/user2.ec6ae432.png";